import React from 'react';
import PropTypes from 'prop-types';

import CancelEvent from './CancelEvent';
import RescheduleEvent from './RescheduleEvent';
import ChangeCaregiver from './ChangeCaregiver';
import DeclineRescheduleRequest from './DeclineRescheduleRequest';
import DeclineCancelRequest from './DeclineCancelRequest';
import AcceptRescheduleRequest from './AcceptRescheduleRequest';
import AcceptCancelRequest from './AcceptCancelRequest';

const Popup = (props) => {
  const {model, setModel, event, handleUpdateEventCaregiver, handleCancelEvent, handleRescheduleEvent, handleDeclineRequest} = props;

  const popModelGenerator = React.useCallback(() => {
    const closeModel = () => {
      setModel(null);
    };

    let popModel = null;
    switch (model) {
      case 'CANCEL':
        popModel = <CancelEvent
          closeModel={closeModel}
          event={event}
          onCancelEvent={handleCancelEvent}
        />;
        break;
      case 'RESCHEDULE':
        popModel = <RescheduleEvent
          closeModel={closeModel}
          event={event}
          onRescheduleEvent={handleRescheduleEvent}
        />;
        break;
      case 'UPDATE_CAREGIVER':
        popModel = <ChangeCaregiver
          closeModel={closeModel}
          event={event}
          onUpdateEventCaregiver={handleUpdateEventCaregiver}
        />;
        break;
      case 'DECLINE_RESCHEDULE_REQUEST':
        popModel = <DeclineRescheduleRequest
          closeModel={closeModel}
          event={event}
          onDeclineEvent={handleDeclineRequest}
        />;
        break;
      case 'DECLINE_CANCEL_REQUEST':
        popModel = <DeclineCancelRequest
          closeModel={closeModel}
          event={event}
          onDeclineEvent={handleDeclineRequest}
        />;
        break;
      case 'ACCEPT_RESCHEDULE_REQUEST':
        popModel = <AcceptRescheduleRequest
          closeModel={closeModel}
          event={event}
          onRescheduleEvent={handleRescheduleEvent}
        />;
        break;
      case 'ACCEPT_CANCEL_REQUEST':
        popModel = <AcceptCancelRequest
          closeModel={closeModel}
          event={event}
          onCancelEvent={handleCancelEvent}
        />;
        break;
      default:
        break;
    }
    return popModel;
  }, [model, event]);

  return (
    <>
      {popModelGenerator()}
    </>
  );
};

Popup.propTypes = {
  model: PropTypes.string,
  setModel: PropTypes.func.isRequired,
  event: PropTypes.object.isRequired,
  handleUpdateEventCaregiver: PropTypes.func.isRequired,
  handleCancelEvent: PropTypes.func.isRequired,
  handleRescheduleEvent: PropTypes.func.isRequired,
  handleDeclineRequest: PropTypes.func.isRequired,
};

export default Popup;
